import { CommonError } from '../../types';
import { OrderBookActions } from './actions';
import { FETCH_ORDER_BOOK_FAILURE, FETCH_ORDER_BOOK_REQUEST, FETCH_ORDER_BOOK_SUCCESS } from './constants';
import { OrderBookData } from './types';

export interface StockOrderBookState {
    orderBookDatas: OrderBookData[];
    loading: boolean;
    error: CommonError | null;
}
const initialState = {
    orderBookDatas: [],
    loading: false,
    error: null,
};
export const StockOrderBookReducer = (state = initialState, action: OrderBookActions): StockOrderBookState => {
    switch (action.type) {
        case FETCH_ORDER_BOOK_REQUEST:
            return { ...state, loading: true, error: null };
        case FETCH_ORDER_BOOK_SUCCESS: {
            return { ...state, loading: false, orderBookDatas: action.payload };
        }
        case FETCH_ORDER_BOOK_FAILURE:{
            return { ...state, loading: false, error: action.payload };
        }
           
        default:
            return state;
    }
};
